import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { logEvent } from '../../../lib/shared/event-logger';
import { ProgressCircleV2 } from '../ProgressCircleV2';
import { RISK_CONFIG, calculateRiskScore, getRiskLevel } from '../../shared/risk-helpers';
import nextImageSrc from '../../assets/images/slide/next-icon.png';
import styles from './RiskSlideV2.css';

const cx = classnames.bind(styles);

function RiskSlideV2({ eventName, results, questionIds, maxRiskScore, scoreThresholds, titlePrefix, variants }) {
    const score = calculateRiskScore(results.userResponses, questionIds);
    const level = getRiskLevel(score, scoreThresholds);
    const { riskLabel, titleSuffix, riskIntro, riskItems, nextStepText } = variants[level];
    const { color, bgColor } = RISK_CONFIG[level];

    useEffect(() => {
        logEvent(eventName, { 'risk_level': level });
    }, []);

    return (
        <div className={styles.root}>
            <ProgressCircleV2
                score={score}
                maxScore={maxRiskScore}
                color={color}
                bgColor={bgColor}
            />
            <p className={styles.title}>
                {titlePrefix} <span className={cx('riskWord', level)}>{riskLabel}</span>{titleSuffix}
            </p>
            <div className={cx('riskBlock', level)}>
                <p>{riskIntro}</p>
                <ul className={styles.list}>
                    {riskItems.map(({ id, alt, text, imageUrl }) => (
                        <li key={id}>
                            <img src={imageUrl} alt={alt} />
                            <p>{text}</p>
                        </li>
                    ))}
                </ul>
            </div>
            <div className={styles.nextStepBlock}>
                <img src={nextImageSrc} alt='next' />
                <p>{nextStepText}</p>
            </div>
        </div>
    );
}

RiskSlideV2.propTypes = {
    eventName: PropTypes.string.isRequired,
    results: PropTypes.shape({
        userResponses: PropTypes.array.isRequired
    }).isRequired,
    questionIds: PropTypes.arrayOf(PropTypes.number).isRequired,
    maxRiskScore: PropTypes.number.isRequired,
    scoreThresholds: PropTypes.shape({
        low: PropTypes.number.isRequired,
        moderate: PropTypes.number.isRequired
    }).isRequired,
    titlePrefix: PropTypes.string.isRequired,
    variants: PropTypes.shape({
        high: PropTypes.object.isRequired,
        moderate: PropTypes.object.isRequired,
        low: PropTypes.object.isRequired
    }).isRequired
};

export {
    RiskSlideV2
};
